import { SystemRoleEnum } from '@olv/ui-shared/enums/system-role.enum';
import { MerchantRoleEnum } from '@olv/ui-shared/enums/merchant-role.enum';

export const SYSTEM_ROLE_NAME_MAP: Record<string, number> = {
  Admin: SystemRoleEnum.Admin,
  'Merchant Preparer': SystemRoleEnum.MerchantPreparer,
  'Merchant Approver': SystemRoleEnum.MerchantApprover,
  'System Preparer': SystemRoleEnum.SystemPreparer,
  'System Approver': SystemRoleEnum.SystemApprover,
  'Reports User': SystemRoleEnum.ReportsUser,
  'Merchant Support Staff': SystemRoleEnum.MerchantSupportStaff,
  'System Support Staff': SystemRoleEnum.SystemSupportStaff,
};

export const MERCHANT_ROLE_NAME_MAP: Record<string, number> = {
  'Merchant Portal Supervisor': MerchantRoleEnum.MerchantPortalSupervisor,
  'Merchant Portal Approver': MerchantRoleEnum.MerchantPortalApprover,
  'Merchant Portal Preparer': MerchantRoleEnum.MerchantPortalPreparer,
  'Merchant Portal Report Viewer': MerchantRoleEnum.MerchantPortalReportViewer,
  'Merchant Portal Support Staff': MerchantRoleEnum.MerchantPortalSupportStaff,
};

export function getRoleNameMap(appName: string): Record<string, number> {
  return appName === 'merchant' ? MERCHANT_ROLE_NAME_MAP : SYSTEM_ROLE_NAME_MAP;
}
